/**
 * @fileoverview This file is generated by the Angular 2 template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties}
 */
 /* tslint:disable */

import * as import0 from '../../../../../../public/upgrade/feature/additionalPoint/phone-component/phone.container.component';
import * as import1 from '@angular/core/src/change_detection/change_detection_util';
import * as import2 from '@angular/core/src/linker/view';
import * as import3 from '@angular/core/src/linker/view_utils';
import * as import4 from '@angular/core/src/render/api';
import * as import5 from '@angular/core/src/metadata/view';
import * as import6 from '@angular/core/src/linker/view_type';
import * as import7 from '@angular/core/src/change_detection/constants';
import * as import8 from '@angular/core/src/linker/component_factory';
import * as import9 from '../../../../../../public/upgrade/core/logger.service';
import * as import10 from '../../../../../../public/upgrade/root/ga/ga.service';
import * as import11 from '@ngx-translate/core/src/translate.pipe';
import * as import12 from '@angular/core/src/linker/view_container';
import * as import13 from '@ngx-translate/core/src/translate.service';
import * as import14 from '../../../../../node_modules/@angular/common/src/directives/ng_class.ngfactory';
import * as import15 from '../../../../../node_modules/@angular/forms/src/directives/default_value_accessor.ngfactory';
import * as import16 from '../../../../../node_modules/angular2-text-mask/dist/angular2TextMask.ngfactory';
import * as import17 from '../../../../../node_modules/@angular/forms/src/directives/ng_model.ngfactory';
import * as import18 from '../../../../../node_modules/@angular/forms/src/directives/ng_control_status.ngfactory';
import * as import19 from '../../../../../node_modules/@angular/common/src/directives/ng_if.ngfactory';
import * as import20 from '@angular/core/src/change_detection/differs/iterable_differs';
import * as import21 from '@angular/core/src/change_detection/differs/keyvalue_differs';
import * as import22 from '@angular/core/src/linker/element_ref';
import * as import23 from '@angular/core/src/linker/template_ref';
import * as import24 from '@angular/forms/src/directives/default_value_accessor';
import * as import25 from 'angular2-text-mask/dist/angular2TextMask';
import * as import26 from '@angular/forms/src/directives/control_value_accessor';
import * as import27 from '@angular/forms/src/directives/ng_model';
import * as import28 from '@angular/forms/src/directives/ng_control';
import * as import29 from '@angular/forms/src/directives/ng_control_status';
import * as import30 from '@angular/common/src/directives/ng_class';
import * as import31 from '@angular/common/src/directives/ng_if';
export class Wrapper_PhoneContainerComponent {
  /*private*/ _eventHandler:Function;
  context:import0.PhoneContainerComponent;
  /*private*/ _changed:boolean;
  /*private*/ _changes:{[key: string]:any};
  /*private*/ _expr_0:any;
  /*private*/ _expr_1:any;
  /*private*/ _expr_2:any;
  /*private*/ _expr_3:any;
  /*private*/ _expr_4:any;
  /*private*/ _expr_5:any;
  /*private*/ _expr_6:any;
  constructor(p0:any,p1:any) {
    this._changed = false;
    this._changes = {};
    this.context = new import0.PhoneContainerComponent(p0,p1);
    this._expr_0 = import1.UNINITIALIZED;
    this._expr_1 = import1.UNINITIALIZED;
    this._expr_2 = import1.UNINITIALIZED;
    this._expr_3 = import1.UNINITIALIZED;
    this._expr_4 = import1.UNINITIALIZED;
    this._expr_5 = import1.UNINITIALIZED;
    this._expr_6 = import1.UNINITIALIZED;
  }
  ngOnDetach(view:import2.AppView<any>,componentView:import2.AppView<any>,el:any):void {
  }
  ngOnDestroy():void {
  }
  check_errors(currValue:any,throwOnChange:boolean,forceUpdate:boolean):void {
    if ((forceUpdate || import3.checkBinding(throwOnChange,this._expr_0,currValue))) {
      this._changed = true;
      this.context.errors = currValue;
      this._changes['errors'] = new import1.SimpleChange(this._expr_0,currValue);
      this._expr_0 = currValue;
    }
  }
  check_dto(currValue:any,throwOnChange:boolean,forceUpdate:boolean):void {
    if ((forceUpdate || import3.checkBinding(throwOnChange,this._expr_1,currValue))) {
      this._changed = true;
      this.context.dto = currValue;
      this._changes['dto'] = new import1.SimpleChange(this._expr_1,currValue);
      this._expr_1 = currValue;
    }
  }
  check_countryId(currValue:any,throwOnChange:boolean,forceUpdate:boolean):void {
    if ((forceUpdate || import3.checkBinding(throwOnChange,this._expr_2,currValue))) {
      this._changed = true;
      this.context.countryId = currValue;
      this._changes['countryId'] = new import1.SimpleChange(this._expr_2,currValue);
      this._expr_2 = currValue;
    }
  }
  check_hasOtherDeliveryMessage(currValue:any,throwOnChange:boolean,forceUpdate:boolean):void {
    if ((forceUpdate || import3.checkBinding(throwOnChange,this._expr_3,currValue))) {
      this._changed = true;
      this.context.hasOtherDeliveryMessage = currValue;
      this._changes['hasOtherDeliveryMessage'] = new import1.SimpleChange(this._expr_3,currValue);
      this._expr_3 = currValue;
    }
  }
  check_phonePrefix(currValue:any,throwOnChange:boolean,forceUpdate:boolean):void {
    if ((forceUpdate || import3.checkBinding(throwOnChange,this._expr_4,currValue))) {
      this._changed = true;
      this.context.phonePrefix = currValue;
      this._changes['phonePrefix'] = new import1.SimpleChange(this._expr_4,currValue);
      this._expr_4 = currValue;
    }
  }
  check_freeLine(currValue:any,throwOnChange:boolean,forceUpdate:boolean):void {
    if ((forceUpdate || import3.checkBinding(throwOnChange,this._expr_5,currValue))) {
      this._changed = true;
      this.context.freeLine = currValue;
      this._changes['freeLine'] = new import1.SimpleChange(this._expr_5,currValue);
      this._expr_5 = currValue;
    }
  }
  check_isValidLocation(currValue:any,throwOnChange:boolean,forceUpdate:boolean):void {
    if ((forceUpdate || import3.checkBinding(throwOnChange,this._expr_6,currValue))) {
      this._changed = true;
      this.context.isValidLocation = currValue;
      this._changes['isValidLocation'] = new import1.SimpleChange(this._expr_6,currValue);
      this._expr_6 = currValue;
    }
  }
  ngDoCheck(view:import2.AppView<any>,el:any,throwOnChange:boolean):boolean {
    var changed:any = this._changed;
    this._changed = false;
    if (!throwOnChange) {
      if (changed) {
        this.context.ngOnChanges(this._changes);
        this._changes = {};
      }
      if ((view.numberOfChecks === 0)) { this.context.ngOnInit(); }
    }
    return changed;
  }
  checkHost(view:import2.AppView<any>,componentView:import2.AppView<any>,el:any,throwOnChange:boolean):void {
  }
  handleEvent(eventName:string,$event:any):boolean {
    var result:boolean = true;
    return result;
  }
  subscribe(view:import2.AppView<any>,_eventHandler:any):void {
    this._eventHandler = _eventHandler;
  }
}
var renderType_PhoneContainerComponent_Host:import4.RenderComponentType = import3.createRenderComponentType('',0,import5.ViewEncapsulation.None,([] as any[]),{});
class View_PhoneContainerComponent_Host0 extends import2.AppView<any> {
  _el_0:any;
  compView_0:import2.AppView<import0.PhoneContainerComponent>;
  _PhoneContainerComponent_0_3:Wrapper_PhoneContainerComponent;
  constructor(viewUtils:import3.ViewUtils,parentView:import2.AppView<any>,parentIndex:number,parentElement:any) {
    super(View_PhoneContainerComponent_Host0,renderType_PhoneContainerComponent_Host,import6.ViewType.HOST,viewUtils,parentView,parentIndex,parentElement,import7.ChangeDetectorStatus.CheckAlways);
  }
  createInternal(rootSelector:string):import8.ComponentRef<any> {
    this._el_0 = import3.selectOrCreateRenderHostElement(this.renderer,'phone-container',import3.EMPTY_INLINE_ARRAY,rootSelector,(null as any));
    this.compView_0 = new View_PhoneContainerComponent0(this.viewUtils,this,0,this._el_0);
    this._PhoneContainerComponent_0_3 = new Wrapper_PhoneContainerComponent(this.injectorGet(import9.LoggerService,this.parentIndex),this.injectorGet(import10.GAService,this.parentIndex));
    this.compView_0.create(this._PhoneContainerComponent_0_3.context);
    this.init(this._el_0,((<any>this.renderer).directRenderer? (null as any): [this._el_0]),(null as any));
    return new import8.ComponentRef_<any>(0,this,this._el_0,this._PhoneContainerComponent_0_3.context);
  }
  injectorGetInternal(token:any,requestNodeIndex:number,notFoundResult:any):any {
    if (((token === import0.PhoneContainerComponent) && (0 === requestNodeIndex))) { return this._PhoneContainerComponent_0_3.context; }
    return notFoundResult;
  }
  detectChangesInternal(throwOnChange:boolean):void {
    this._PhoneContainerComponent_0_3.ngDoCheck(this,this._el_0,throwOnChange);
    this.compView_0.internalDetectChanges(throwOnChange);
    if (!throwOnChange) { if ((this.numberOfChecks === 0)) { this._PhoneContainerComponent_0_3.context.ngAfterViewInit(); } }
  }
  destroyInternal():void {
    this.compView_0.destroy();
  }
  visitRootNodesInternal(cb:any,ctx:any):void {
    cb(this._el_0,ctx);
  }
}
export const PhoneContainerComponentNgFactory:import8.ComponentFactory<import0.PhoneContainerComponent> = new import8.ComponentFactory<import0.PhoneContainerComponent>('phone-container',View_PhoneContainerComponent_Host0,import0.PhoneContainerComponent);
const styles_PhoneContainerComponent:any[] = ([] as any[]);
class View_PhoneContainerComponent1 extends import2.AppView<any> {
  _el_0:any;
  _text_1:any;
  _el_2:any;
  _text_3:any;
  /*private*/ _expr_4:any;
  _pipe_translate_0:import11.TranslatePipe;
  constructor(viewUtils:import3.ViewUtils,parentView:import2.AppView<any>,parentIndex:number,parentElement:any,declaredViewContainer:import12.ViewContainer) {
    super(View_PhoneContainerComponent1,renderType_PhoneContainerComponent,import6.ViewType.EMBEDDED,viewUtils,parentView,parentIndex,parentElement,import7.ChangeDetectorStatus.CheckAlways,declaredViewContainer);
    this._expr_4 = import1.UNINITIALIZED;
  }
  createInternal(rootSelector:string):import8.ComponentRef<any> {
    this._el_0 = import3.createRenderElement(this.renderer,(null as any),'div',new import3.InlineArray2(2,'class','content-invalid-inline'),(null as any));
    this._text_1 = this.renderer.createText(this._el_0,'\n                ',(null as any));
    this._el_2 = import3.createRenderElement(this.renderer,this._el_0,'i',new import3.InlineArray2(2,'class','eva-3-icon-error-circle icon-inline'),(null as any));
    this._text_3 = this.renderer.createText(this._el_0,'',(null as any));
    this._pipe_translate_0 = new import11.TranslatePipe(this.parentView.injectorGet(import13.TranslateService,this.parentIndex),this.parentView.ref);
    this.init(this._el_0,((<any>this.renderer).directRenderer? (null as any): [
      this._el_0,
      this._text_1,
      this._el_2,
      this._text_3
    ]
    ),(null as any));
    return (null as any);
  }
  detectChangesInternal(throwOnChange:boolean):void {
    const valUnwrapper:any = new import1.ValueUnwrapper();
    valUnwrapper.reset();
    const currVal_4:any = import3.inlineInterpolate(1,'',valUnwrapper.unwrap(this._pipe_translate_0.transform('pickupPoint.phone.missing.digit')),'\n            ');
    if ((valUnwrapper.hasWrappedValue || import3.checkBinding(throwOnChange,this._expr_4,currVal_4))) {
      this.renderer.setText(this._text_3,currVal_4);
      this._expr_4 = currVal_4;
    }
  }
  destroyInternal():void {
    this._pipe_translate_0.ngOnDestroy();
  }
  visitRootNodesInternal(cb:any,ctx:any):void {
    cb(this._el_0,ctx);
  }
}
class View_PhoneContainerComponent2 extends import2.AppView<any> {
  _el_0:any;
  _text_1:any;
  _el_2:any;
  _text_3:any;
  /*private*/ _expr_4:any;
  _pipe_translate_0:import11.TranslatePipe;
  constructor(viewUtils:import3.ViewUtils,parentView:import2.AppView<any>,parentIndex:number,parentElement:any,declaredViewContainer:import12.ViewContainer) {
    super(View_PhoneContainerComponent2,renderType_PhoneContainerComponent,import6.ViewType.EMBEDDED,viewUtils,parentView,parentIndex,parentElement,import7.ChangeDetectorStatus.CheckAlways,declaredViewContainer);
    this._expr_4 = import1.UNINITIALIZED;
  }
  createInternal(rootSelector:string):import8.ComponentRef<any> {
    this._el_0 = import3.createRenderElement(this.renderer,(null as any),'div',new import3.InlineArray2(2,'class','content-invalid-inline'),(null as any));
    this._text_1 = this.renderer.createText(this._el_0,'\n                ',(null as any));
    this._el_2 = import3.createRenderElement(this.renderer,this._el_0,'i',new import3.InlineArray2(2,'class','eva-3-icon-error-circle icon-inline'),(null as any));
    this._text_3 = this.renderer.createText(this._el_0,'',(null as any));
    this._pipe_translate_0 = new import11.TranslatePipe(this.parentView.injectorGet(import13.TranslateService,this.parentIndex),this.parentView.ref);
    this.init(this._el_0,((<any>this.renderer).directRenderer? (null as any): [
      this._el_0,
      this._text_1,
      this._el_2,
      this._text_3
    ]
    ),(null as any));
    return (null as any);
  }
  detectChangesInternal(throwOnChange:boolean):void {
    const valUnwrapper:any = new import1.ValueUnwrapper();
    valUnwrapper.reset();
    const currVal_4:any = import3.inlineInterpolate(1,'',valUnwrapper.unwrap(this._pipe_translate_0.transform('pickupPoint.phone.missing')),'\n            ');
    if ((valUnwrapper.hasWrappedValue || import3.checkBinding(throwOnChange,this._expr_4,currVal_4))) {
      this.renderer.setText(this._text_3,currVal_4);
      this._expr_4 = currVal_4;
    }
  }
  destroyInternal():void {
    this._pipe_translate_0.ngOnDestroy();
  }
  visitRootNodesInternal(cb:any,ctx:any):void {
    cb(this._el_0,ctx);
  }
}
class View_PhoneContainerComponent3 extends import2.AppView<any> {
  _el_0:any;
  _text_1:any;
  /*private*/ _expr_2:any;
  _pipe_translate_0:import11.TranslatePipe;
  constructor(viewUtils:import3.ViewUtils,parentView:import2.AppView<any>,parentIndex:number,parentElement:any,declaredViewContainer:import12.ViewContainer) {
    super(View_PhoneContainerComponent3,renderType_PhoneContainerComponent,import6.ViewType.EMBEDDED,viewUtils,parentView,parentIndex,parentElement,import7.ChangeDetectorStatus.CheckAlways,declaredViewContainer);
    this._expr_2 = import1.UNINITIALIZED;
  }
  createInternal(rootSelector:string):import8.ComponentRef<any> {
    this._el_0 = import3.createRenderElement(this.renderer,(null as any),'p',new import3.InlineArray2(2,'class','eva-3-h6 -eva-3-tc-blue-4 text-bold'),(null as any));
    this._text_1 = this.renderer.createText(this._el_0,'',(null as any));
    this._pipe_translate_0 = new import11.TranslatePipe(this.parentView.injectorGet(import13.TranslateService,this.parentIndex),this.parentView.ref);
    this.init(this._el_0,((<any>this.renderer).directRenderer? (null as any): [
      this._el_0,
      this._text_1
    ]
    ),(null as any));
    return (null as any);
  }
  detectChangesInternal(throwOnChange:boolean):void {
    const valUnwrapper:any = new import1.ValueUnwrapper();
    valUnwrapper.reset();
    const currVal_2:any = import3.inlineInterpolate(1,' ',valUnwrapper.unwrap(this._pipe_translate_0.transform('PhoneTollFree')),' ');
    if ((valUnwrapper.hasWrappedValue || import3.checkBinding(throwOnChange,this._expr_2,currVal_2))) {
      this.renderer.setText(this._text_1,currVal_2);
      this._expr_2 = currVal_2;
    }
  }
  destroyInternal():void {
    this._pipe_translate_0.ngOnDestroy();
  }
  visitRootNodesInternal(cb:any,ctx:any):void {
    cb(this._el_0,ctx);
  }
}
class View_PhoneContainerComponent4 extends import2.AppView<any> {
  _el_0:any;
  _text_1:any;
  _el_2:any;
  _text_3:any;
  /*private*/ _expr_4:any;
  _pipe_translate_0:import11.TranslatePipe;
  constructor(viewUtils:import3.ViewUtils,parentView:import2.AppView<any>,parentIndex:number,parentElement:any,declaredViewContainer:import12.ViewContainer) {
    super(View_PhoneContainerComponent4,renderType_PhoneContainerComponent,import6.ViewType.EMBEDDED,viewUtils,parentView,parentIndex,parentElement,import7.ChangeDetectorStatus.CheckAlways,declaredViewContainer);
    this._expr_4 = import1.UNINITIALIZED;
  }
  createInternal(rootSelector:string):import8.ComponentRef<any> {
    this._el_0 = import3.createRenderElement(this.renderer,(null as any),'div',new import3.InlineArray2(2,'class','content-invalid-inline'),(null as any));
    this._text_1 = this.renderer.createText(this._el_0,'\n                ',(null as any));
    this._el_2 = import3.createRenderElement(this.renderer,this._el_0,'i',new import3.InlineArray2(2,'class','eva-3-icon-error-circle icon-inline'),(null as any));
    this._text_3 = this.renderer.createText(this._el_0,'',(null as any));
    this._pipe_translate_0 = new import11.TranslatePipe(this.parentView.injectorGet(import13.TranslateService,this.parentIndex),this.parentView.ref);
    this.init(this._el_0,((<any>this.renderer).directRenderer? (null as any): [
      this._el_0,
      this._text_1,
      this._el_2,
      this._text_3
    ]
    ),(null as any));
    return (null as any);
  }
  detectChangesInternal(throwOnChange:boolean):void {
    const valUnwrapper:any = new import1.ValueUnwrapper();
    valUnwrapper.reset();
    const currVal_4:any = import3.inlineInterpolate(1,'',valUnwrapper.unwrap(this._pipe_translate_0.transform('pickupPoint.phone.missing.digit')),'\n            ');
    if ((valUnwrapper.hasWrappedValue || import3.checkBinding(throwOnChange,this._expr_4,currVal_4))) {
      this.renderer.setText(this._text_3,currVal_4);
      this._expr_4 = currVal_4;
    }
  }
  destroyInternal():void {
    this._pipe_translate_0.ngOnDestroy();
  }
  visitRootNodesInternal(cb:any,ctx:any):void {
    cb(this._el_0,ctx);
  }
}
class View_PhoneContainerComponent5 extends import2.AppView<any> {
  _el_0:any;
  _text_1:any;
  _el_2:any;
  _text_3:any;
  /*private*/ _expr_4:any;
  _pipe_translate_0:import11.TranslatePipe;
  constructor(viewUtils:import3.ViewUtils,parentView:import2.AppView<any>,parentIndex:number,parentElement:any,declaredViewContainer:import12.ViewContainer) {
    super(View_PhoneContainerComponent5,renderType_PhoneContainerComponent,import6.ViewType.EMBEDDED,viewUtils,parentView,parentIndex,parentElement,import7.ChangeDetectorStatus.CheckAlways,declaredViewContainer);
    this._expr_4 = import1.UNINITIALIZED;
  }
  createInternal(rootSelector:string):import8.ComponentRef<any> {
    this._el_0 = import3.createRenderElement(this.renderer,(null as any),'div',new import3.InlineArray2(2,'class','content-invalid-inline'),(null as any));
    this._text_1 = this.renderer.createText(this._el_0,'\n                ',(null as any));
    this._el_2 = import3.createRenderElement(this.renderer,this._el_0,'i',new import3.InlineArray2(2,'class','eva-3-icon-error-circle icon-inline'),(null as any));
    this._text_3 = this.renderer.createText(this._el_0,'',(null as any));
    this._pipe_translate_0 = new import11.TranslatePipe(this.parentView.injectorGet(import13.TranslateService,this.parentIndex),this.parentView.ref);
    this.init(this._el_0,((<any>this.renderer).directRenderer? (null as any): [
      this._el_0,
      this._text_1,
      this._el_2,
      this._text_3
    ]
    ),(null as any));
    return (null as any);
  }
  detectChangesInternal(throwOnChange:boolean):void {
    const valUnwrapper:any = new import1.ValueUnwrapper();
    valUnwrapper.reset();
    const currVal_4:any = import3.inlineInterpolate(1,'',valUnwrapper.unwrap(this._pipe_translate_0.transform('pickupPoint.phone.missing')),'\n            ');
    if ((valUnwrapper.hasWrappedValue || import3.checkBinding(throwOnChange,this._expr_4,currVal_4))) {
      this.renderer.setText(this._text_3,currVal_4);
      this._expr_4 = currVal_4;
    }
  }
  destroyInternal():void {
    this._pipe_translate_0.ngOnDestroy();
  }
  visitRootNodesInternal(cb:any,ctx:any):void {
    cb(this._el_0,ctx);
  }
}
class View_PhoneContainerComponent6 extends import2.AppView<any> {
  _el_0:any;
  _text_1:any;
  /*private*/ _expr_2:any;
  _pipe_translate_0:import11.TranslatePipe;
  constructor(viewUtils:import3.ViewUtils,parentView:import2.AppView<any>,parentIndex:number,parentElement:any,declaredViewContainer:import12.ViewContainer) {
    super(View_PhoneContainerComponent6,renderType_PhoneContainerComponent,import6.ViewType.EMBEDDED,viewUtils,parentView,parentIndex,parentElement,import7.ChangeDetectorStatus.CheckAlways,declaredViewContainer);
    this._expr_2 = import1.UNINITIALIZED;
  }
  createInternal(rootSelector:string):import8.ComponentRef<any> {
    this._el_0 = import3.createRenderElement(this.renderer,(null as any),'p',new import3.InlineArray2(2,'class','eva-3-h6 -eva-3-tc-blue-4 text-bold'),(null as any));
    this._text_1 = this.renderer.createText(this._el_0,'',(null as any));
    this._pipe_translate_0 = new import11.TranslatePipe(this.parentView.injectorGet(import13.TranslateService,this.parentIndex),this.parentView.ref);
    this.init(this._el_0,((<any>this.renderer).directRenderer? (null as any): [
      this._el_0,
      this._text_1
    ]
    ),(null as any));
    return (null as any);
  }
  detectChangesInternal(throwOnChange:boolean):void {
    const valUnwrapper:any = new import1.ValueUnwrapper();
    valUnwrapper.reset();
    const currVal_2:any = import3.inlineInterpolate(1,' ',valUnwrapper.unwrap(this._pipe_translate_0.transform('PhoneTollFree')),' ');
    if ((valUnwrapper.hasWrappedValue || import3.checkBinding(throwOnChange,this._expr_2,currVal_2))) {
      this.renderer.setText(this._text_1,currVal_2);
      this._expr_2 = currVal_2;
    }
  }
  destroyInternal():void {
    this._pipe_translate_0.ngOnDestroy();
  }
  visitRootNodesInternal(cb:any,ctx:any):void {
    cb(this._el_0,ctx);
  }
}
var renderType_PhoneContainerComponent:import4.RenderComponentType = import3.createRenderComponentType('',0,import5.ViewEncapsulation.None,styles_PhoneContainerComponent,{});
export class View_PhoneContainerComponent0 extends import2.AppView<import0.PhoneContainerComponent> {
  _el_0:any;
  _text_1:any;
  _text_2:any;
  _el_3:any;
  _text_4:any;
  _text_5:any;
  _el_6:any;
  _text_7:any;
  _el_8:any;
  _text_9:any;
  _el_10:any;
  _NgClass_10_3:import14.Wrapper_NgClass;
  _text_11:any;
  _el_12:any;
  _text_13:any;
  _el_14:any;
  _text_15:any;
  _el_16:any;
  _DefaultValueAccessor_16_3:import15.Wrapper_DefaultValueAccessor;
  _MaskedInputDirective_16_4:import16.Wrapper_MaskedInputDirective;
  _NG_VALUE_ACCESSOR_16_5:any[];
  _NgModel_16_6:import17.Wrapper_NgModel;
  _NgControl_16_7:any;
  _NgControlStatus_16_8:import18.Wrapper_NgControlStatus;
  _text_17:any;
  _el_18:any;
  _NgClass_18_3:import14.Wrapper_NgClass;
  _text_19:any;
  _text_20:any;
  _text_21:any;
  _text_22:any;
  _text_23:any;
  _text_24:any;
  _el_25:any;
  _text_26:any;
  _el_27:any;
  _NgClass_27_3:import14.Wrapper_NgClass;
  _text_28:any;
  _text_29:any;
  _el_30:any;
  _NgClass_30_3:import14.Wrapper_NgClass;
  _text_31:any;
  _el_32:any;
  _text_33:any;
  _el_34:any;
  _DefaultValueAccessor_34_3:import15.Wrapper_DefaultValueAccessor;
  _MaskedInputDirective_34_4:import16.Wrapper_MaskedInputDirective;
  _NG_VALUE_ACCESSOR_34_5:any[];
  _NgModel_34_6:import17.Wrapper_NgModel;
  _NgControl_34_7:any;
  _NgControlStatus_34_8:import18.Wrapper_NgControlStatus;
  _text_35:any;
  _el_36:any;
  _NgClass_36_3:import14.Wrapper_NgClass;
  _text_37:any;
  _text_38:any;
  _text_39:any;
  _text_40:any;
  _text_41:any;
  _el_42:any;
  _text_43:any;
  _el_44:any;
  _text_45:any;
  _text_46:any;
  _text_47:any;
  _el_48:any;
  _text_49:any;
  _el_50:any;
  _text_51:any;
  _el_52:any;
  _text_53:any;
  _anchor_54:any;
  /*private*/ _vc_54:import12.ViewContainer;
  _TemplateRef_54_5:any;
  _NgIf_54_6:import19.Wrapper_NgIf;
  _text_55:any;
  _anchor_56:any;
  /*private*/ _vc_56:import12.ViewContainer;
  _TemplateRef_56_5:any;
  _NgIf_56_6:import19.Wrapper_NgIf;
  _text_57:any;
  _text_58:any;
  _anchor_59:any;
  /*private*/ _vc_59:import12.ViewContainer;
  _TemplateRef_59_5:any;
  _NgIf_59_6:import19.Wrapper_NgIf;
  _text_60:any;
  _text_61:any;
  _el_62:any;
  _text_63:any;
  _el_64:any;
  _text_65:any;
  _anchor_66:any;
  /*private*/ _vc_66:import12.ViewContainer;
  _TemplateRef_66_5:any;
  _NgIf_66_6:import19.Wrapper_NgIf;
  _text_67:any;
  _anchor_68:any;
  /*private*/ _vc_68:import12.ViewContainer;
  _TemplateRef_68_5:any;
  _NgIf_68_6:import19.Wrapper_NgIf;
  _text_69:any;
  _text_70:any;
  _anchor_71:any;
  /*private*/ _vc_71:import12.ViewContainer;
  _TemplateRef_71_5:any;
  _NgIf_71_6:import19.Wrapper_NgIf;
  _text_72:any;
  _text_73:any;
  _text_74:any;
  /*private*/ _expr_110:any;
  _pipe_translate_0:import11.TranslatePipe;
  /*private*/ _expr_112:any;
  _pipe_translate_1:import11.TranslatePipe;
  _map_114:any;
  _map_115:any;
  _map_116:any;
  /*private*/ _expr_117:any;
  /*private*/ _expr_118:any;
  _map_119:any;
  /*private*/ _expr_120:any;
  _pipe_translate_2:import11.TranslatePipe;
  /*private*/ _expr_122:any;
  _map_123:any;
  _map_124:any;
  /*private*/ _expr_125:any;
  _map_126:any;
  /*private*/ _expr_127:any;
  /*private*/ _expr_128:any;
  constructor(viewUtils:import3.ViewUtils,parentView:import2.AppView<any>,parentIndex:number,parentElement:any) {
    super(View_PhoneContainerComponent0,renderType_PhoneContainerComponent,import6.ViewType.COMPONENT,viewUtils,parentView,parentIndex,parentElement,import7.ChangeDetectorStatus.CheckAlways);
    this._expr_110 = import1.UNINITIALIZED;
    this._expr_112 = import1.UNINITIALIZED;
    this._map_114 = import3.pureProxy1((p0:any):{[key: string]:any} => {
      return {'-invalid': p0};
    });
    this._map_115 = import3.pureProxy2((p0:any,p1:any):{[key: string]:any} => {
      return {
        mask: p0,
        keepCharPositions: p1
      }
      ;
    });
    this._map_116 = import3.pureProxy1((p0:any):{[key: string]:any} => {
      return {'-isDisabled': p0};
    });
    this._expr_117 = import1.UNINITIALIZED;
    this._expr_118 = import1.UNINITIALIZED;
    this._map_119 = import3.pureProxy1((p0:any):{[key: string]:any} => {
      return {'-disable add-disable': p0};
    });
    this._expr_120 = import1.UNINITIALIZED;
    this._expr_122 = import1.UNINITIALIZED;
    this._map_123 = import3.pureProxy1((p0:any):{[key: string]:any} => {
      return {'-invalid': p0};
    });
    this._map_124 = import3.pureProxy2((p0:any,p1:any):{[key: string]:any} => {
      return {
        mask: p0,
        keepCharPositions: p1
      }
      ;
    });
    this._expr_125 = import1.UNINITIALIZED;
    this._map_126 = import3.pureProxy1((p0:any):{[key: string]:any} => {
      return {'-isDisabled': p0};
    });
    this._expr_127 = import1.UNINITIALIZED;
    this._expr_128 = import1.UNINITIALIZED;
  }
  createInternal(rootSelector:string):import8.ComponentRef<any> {
    const parentRenderNode:any = this.renderer.createViewRoot(this.parentElement);
    this._el_0 = import3.createRenderElement(this.renderer,parentRenderNode,'h6',new import3.InlineArray2(2,'class','sara-reva-eva-3-overline-1 margin-title subtitle-size font-weight-normal'),(null as any));
    this._text_1 = this.renderer.createText(this._el_0,'',(null as any));
    this._text_2 = this.renderer.createText(parentRenderNode,'\n',(null as any));
    this._el_3 = import3.createRenderElement(this.renderer,parentRenderNode,'p',new import3.InlineArray2(2,'class','-h6 -eva-3-tc-gray-2 -eva-3-mt-sm'),(null as any));
    this._text_4 = this.renderer.createText(this._el_3,'',(null as any));
    this._text_5 = this.renderer.createText(parentRenderNode,'\n\n',(null as any));
    this._el_6 = import3.createRenderElement(this.renderer,parentRenderNode,'div',new import3.InlineArray2(2,'class','eva-3-row flex-container'),(null as any));
    this._text_7 = this.renderer.createText(this._el_6,'\n    ',(null as any));
    this._el_8 = import3.createRenderElement(this.renderer,this._el_6,'div',new import3.InlineArray2(2,'class','col -lg-4 -md-4 -sm-4 sara-col'),(null as any));
    this._text_9 = this.renderer.createText(this._el_8,'\n        ',(null as any));
    this._el_10 = import3.createRenderElement(this.renderer,this._el_8,'div',new import3.InlineArray2(2,'class','eva-3-validation -lg -top-left'),(null as any));
    this._NgClass_10_3 = new import14.Wrapper_NgClass(this.parentView.injectorGet(import20.IterableDiffers,this.parentIndex),this.parentView.injectorGet(import21.KeyValueDiffers,this.parentIndex),new import22.ElementRef(this._el_10),this.renderer);
    this._text_11 = this.renderer.createText(this._el_10,'\n            ',(null as any));
    this._el_12 = import3.createRenderElement(this.renderer,this._el_10,'div',new import3.InlineArray2(2,'class','eva-3-input -lg input-phone'),(null as any));
    this._text_13 = this.renderer.createText(this._el_12,'\n                ',(null as any));
    this._el_14 = import3.createRenderElement(this.renderer,this._el_12,'div',new import3.InlineArray2(2,'class','input-container container-inputs'),(null as any));
    this._text_15 = this.renderer.createText(this._el_14,'\n                    ',(null as any));
    this._el_16 = import3.createRenderElement(this.renderer,this._el_14,'input',new import3.InlineArray8(6,'class','input-tag input-phone-padding','id','eva-input-1','type','tel'),(null as any));
    this._DefaultValueAccessor_16_3 = new import15.Wrapper_DefaultValueAccessor(this.renderer,new import22.ElementRef(this._el_16));
    this._MaskedInputDirective_16_4 = new import16.Wrapper_MaskedInputDirective(this.renderer,new import22.ElementRef(this._el_16));
    this._NG_VALUE_ACCESSOR_16_5 = [
      this._DefaultValueAccessor_16_3.context,
      this._MaskedInputDirective_16_4.context
    ]
    ;
    this._NgModel_16_6 = new import17.Wrapper_NgModel((null as any),(null as any),(null as any),this._NG_VALUE_ACCESSOR_16_5);
    this._NgControl_16_7 = this._NgModel_16_6.context;
    this._NgControlStatus_16_8 = new import18.Wrapper_NgControlStatus(this._NgControl_16_7);
    this._text_17 = this.renderer.createText(this._el_14,'\n                    ',(null as any));
    this._el_18 = import3.createRenderElement(this.renderer,this._el_14,'span',new import3.InlineArray2(2,'class','eva-3-label -md phone-prefix'),(null as any));
    this._NgClass_18_3 = new import14.Wrapper_NgClass(this.parentView.injectorGet(import20.IterableDiffers,this.parentIndex),this.parentView.injectorGet(import21.KeyValueDiffers,this.parentIndex),new import22.ElementRef(this._el_18),this.renderer);
    this._text_19 = this.renderer.createText(this._el_18,'',(null as any));
    this._text_20 = this.renderer.createText(this._el_14,'\n                ',(null as any));
    this._text_21 = this.renderer.createText(this._el_12,'\n            ',(null as any));
    this._text_22 = this.renderer.createText(this._el_10,'\n        ',(null as any));
    this._text_23 = this.renderer.createText(this._el_8,'\n    ',(null as any));
    this._text_24 = this.renderer.createText(this._el_6,'\n    ',(null as any));
    this._el_25 = import3.createRenderElement(this.renderer,this._el_6,'div',new import3.InlineArray2(2,'class','col -lg-4 -md-4 -sm-4 sara-col'),(null as any));
    this._text_26 = this.renderer.createText(this._el_25,'\n        ',(null as any));
    this._el_27 = import3.createRenderElement(this.renderer,this._el_25,'a',new import3.InlineArray2(2,'class','eva-3-link'),(null as any));
    this._NgClass_27_3 = new import14.Wrapper_NgClass(this.parentView.injectorGet(import20.IterableDiffers,this.parentIndex),this.parentView.injectorGet(import21.KeyValueDiffers,this.parentIndex),new import22.ElementRef(this._el_27),this.renderer);
    this._text_28 = this.renderer.createText(this._el_27,'',(null as any));
    this._text_29 = this.renderer.createText(this._el_25,'\n        ',(null as any));
    this._el_30 = import3.createRenderElement(this.renderer,this._el_25,'div',new import3.InlineArray2(2,'class','eva-3-input -lg input-phone'),(null as any));
    this._NgClass_30_3 = new import14.Wrapper_NgClass(this.parentView.injectorGet(import20.IterableDiffers,this.parentIndex),this.parentView.injectorGet(import21.KeyValueDiffers,this.parentIndex),new import22.ElementRef(this._el_30),this.renderer);
    this._text_31 = this.renderer.createText(this._el_30,'\n            ',(null as any));
    this._el_32 = import3.createRenderElement(this.renderer,this._el_30,'div',new import3.InlineArray2(2,'class','input-container container-inputs'),(null as any));
    this._text_33 = this.renderer.createText(this._el_32,'\n                ',(null as any));
    this._el_34 = import3.createRenderElement(this.renderer,this._el_32,'input',new import3.InlineArray8(6,'class','input-tag input-phone-padding','id','eva-input-2','type','tel'),(null as any));
    this._DefaultValueAccessor_34_3 = new import15.Wrapper_DefaultValueAccessor(this.renderer,new import22.ElementRef(this._el_34));
    this._MaskedInputDirective_34_4 = new import16.Wrapper_MaskedInputDirective(this.renderer,new import22.ElementRef(this._el_34));
    this._NG_VALUE_ACCESSOR_34_5 = [
      this._DefaultValueAccessor_34_3.context,
      this._MaskedInputDirective_34_4.context
    ]
    ;
    this._NgModel_34_6 = new import17.Wrapper_NgModel((null as any),(null as any),(null as any),this._NG_VALUE_ACCESSOR_34_5);
    this._NgControl_34_7 = this._NgModel_34_6.context;
    this._NgControlStatus_34_8 = new import18.Wrapper_NgControlStatus(this._NgControl_34_7);
    this._text_35 = this.renderer.createText(this._el_32,'\n                ',(null as any));
    this._el_36 = import3.createRenderElement(this.renderer,this._el_32,'span',new import3.InlineArray2(2,'class','eva-3-label -md phone-prefix'),(null as any));
    this._NgClass_36_3 = new import14.Wrapper_NgClass(this.parentView.injectorGet(import20.IterableDiffers,this.parentIndex),this.parentView.injectorGet(import21.KeyValueDiffers,this.parentIndex),new import22.ElementRef(this._el_36),this.renderer);
    this._text_37 = this.renderer.createText(this._el_36,'',(null as any));
    this._text_38 = this.renderer.createText(this._el_32,'\n            ',(null as any));
    this._text_39 = this.renderer.createText(this._el_30,'\n        ',(null as any));
    this._text_40 = this.renderer.createText(this._el_25,'\n\n    ',(null as any));
    this._text_41 = this.renderer.createText(this._el_6,'\n    ',(null as any));
    this._el_42 = import3.createRenderElement(this.renderer,this._el_6,'div',new import3.InlineArray2(2,'class','col -lg-4 -md-4 -sm-4'),(null as any));
    this._text_43 = this.renderer.createText(this._el_42,'\n        ',(null as any));
    this._el_44 = import3.createRenderElement(this.renderer,this._el_42,'i',new import3.InlineArray2(2,'class','-eva-3-icon-md eva-3-icon-trash -eva-3-tc-light-blue-3'),(null as any));
    this._text_45 = this.renderer.createText(this._el_42,'\n    ',(null as any));
    this._text_46 = this.renderer.createText(this._el_6,'\n',(null as any));
    this._text_47 = this.renderer.createText(parentRenderNode,'\n',(null as any));
    this._el_48 = import3.createRenderElement(this.renderer,parentRenderNode,'div',new import3.InlineArray2(2,'class','eva-3-row flex-container free-line'),(null as any));
    this._text_49 = this.renderer.createText(this._el_48,'\n    ',(null as any));
    this._el_50 = import3.createRenderElement(this.renderer,this._el_48,'div',new import3.InlineArray2(2,'class','col -lg-4 -md-4 -sm-4 sara-col'),(null as any));
    this._text_51 = this.renderer.createText(this._el_50,'\n        ',(null as any));
    this._el_52 = import3.createRenderElement(this.renderer,this._el_50,'div',new import3.InlineArray2(2,'class','content eva-3-validation-inline -invalid'),(null as any));
    this._text_53 = this.renderer.createText(this._el_52,'\n            ',(null as any));
    this._anchor_54 = this.renderer.createTemplateAnchor(this._el_52,(null as any));
    this._vc_54 = new import12.ViewContainer(54,52,this,this._anchor_54);
    this._TemplateRef_54_5 = new import23.TemplateRef_(this,54,this._anchor_54);
    this._NgIf_54_6 = new import19.Wrapper_NgIf(this._vc_54.vcRef,this._TemplateRef_54_5);
    this._text_55 = this.renderer.createText(this._el_52,'\n            ',(null as any));
    this._anchor_56 = this.renderer.createTemplateAnchor(this._el_52,(null as any));
    this._vc_56 = new import12.ViewContainer(56,52,this,this._anchor_56);
    this._TemplateRef_56_5 = new import23.TemplateRef_(this,56,this._anchor_56);
    this._NgIf_56_6 = new import19.Wrapper_NgIf(this._vc_56.vcRef,this._TemplateRef_56_5);
    this._text_57 = this.renderer.createText(this._el_52,'\n        ',(null as any));
    this._text_58 = this.renderer.createText(this._el_50,'\n        ',(null as any));
    this._anchor_59 = this.renderer.createTemplateAnchor(this._el_50,(null as any));
    this._vc_59 = new import12.ViewContainer(59,50,this,this._anchor_59);
    this._TemplateRef_59_5 = new import23.TemplateRef_(this,59,this._anchor_59);
    this._NgIf_59_6 = new import19.Wrapper_NgIf(this._vc_59.vcRef,this._TemplateRef_59_5);
    this._text_60 = this.renderer.createText(this._el_50,'\n    ',(null as any));
    this._text_61 = this.renderer.createText(this._el_48,'\n    ',(null as any));
    this._el_62 = import3.createRenderElement(this.renderer,this._el_48,'div',new import3.InlineArray2(2,'class','col -lg-4 -md-4 -sm-4 sara-col'),(null as any));
    this._text_63 = this.renderer.createText(this._el_62,'\n        ',(null as any));
    this._el_64 = import3.createRenderElement(this.renderer,this._el_62,'div',new import3.InlineArray2(2,'class','content eva-3-validation-inline -invalid'),(null as any));
    this._text_65 = this.renderer.createText(this._el_64,'\n            ',(null as any));
    this._anchor_66 = this.renderer.createTemplateAnchor(this._el_64,(null as any));
    this._vc_66 = new import12.ViewContainer(66,64,this,this._anchor_66);
    this._TemplateRef_66_5 = new import23.TemplateRef_(this,66,this._anchor_66);
    this._NgIf_66_6 = new import19.Wrapper_NgIf(this._vc_66.vcRef,this._TemplateRef_66_5);
    this._text_67 = this.renderer.createText(this._el_64,'\n            ',(null as any));
    this._anchor_68 = this.renderer.createTemplateAnchor(this._el_64,(null as any));
    this._vc_68 = new import12.ViewContainer(68,64,this,this._anchor_68);
    this._TemplateRef_68_5 = new import23.TemplateRef_(this,68,this._anchor_68);
    this._NgIf_68_6 = new import19.Wrapper_NgIf(this._vc_68.vcRef,this._TemplateRef_68_5);
    this._text_69 = this.renderer.createText(this._el_64,'\n        ',(null as any));
    this._text_70 = this.renderer.createText(this._el_62,'\n        ',(null as any));
    this._anchor_71 = this.renderer.createTemplateAnchor(this._el_62,(null as any));
    this._vc_71 = new import12.ViewContainer(71,62,this,this._anchor_71);
    this._TemplateRef_71_5 = new import23.TemplateRef_(this,71,this._anchor_71);
    this._NgIf_71_6 = new import19.Wrapper_NgIf(this._vc_71.vcRef,this._TemplateRef_71_5);
    this._text_72 = this.renderer.createText(this._el_62,'\n    ',(null as any));
    this._text_73 = this.renderer.createText(this._el_48,'\n',(null as any));
    this._text_74 = this.renderer.createText(parentRenderNode,'\n\n',(null as any));
    this._pipe_translate_0 = new import11.TranslatePipe(this.parentView.injectorGet(import13.TranslateService,this.parentIndex),this.ref);
    this._pipe_translate_1 = new import11.TranslatePipe(this.parentView.injectorGet(import13.TranslateService,this.parentIndex),this.ref);
    var disposable_0:Function = import3.subscribeToRenderElement(this,this._el_16,new import3.InlineArray8(8,'blur',(null as any),'ngModelChange',(null as any),'keyup',(null as any),'input',(null as any)),this.eventHandler(this.handleEvent_16));
    this._NgModel_16_6.subscribe(this,this.eventHandler(this.handleEvent_16),true);
    var disposable_1:Function = import3.subscribeToRenderElement(this,this._el_27,new import3.InlineArray2(2,'click',(null as any)),this.eventHandler(this.handleEvent_27));
    this._pipe_translate_2 = new import11.TranslatePipe(this.parentView.injectorGet(import13.TranslateService,this.parentIndex),this.ref);
    var disposable_2:Function = import3.subscribeToRenderElement(this,this._el_34,new import3.InlineArray8(8,'blur',(null as any),'ngModelChange',(null as any),'keyup',(null as any),'input',(null as any)),this.eventHandler(this.handleEvent_34));
    this._NgModel_34_6.subscribe(this,this.eventHandler(this.handleEvent_34),true);
    var disposable_3:Function = import3.subscribeToRenderElement(this,this._el_44,new import3.InlineArray2(2,'click',(null as any)),this.eventHandler(this.handleEvent_44));
    this.init((null as any),((<any>this.renderer).directRenderer? (null as any): [
      this._el_0,
      this._text_1,
      this._text_2,
      this._el_3,
      this._text_4,
      this._text_5,
      this._el_6,
      this._text_7,
      this._el_8,
      this._text_9,
      this._el_10,
      this._text_11,
      this._el_12,
      this._text_13,
      this._el_14,
      this._text_15,
      this._el_16,
      this._text_17,
      this._el_18,
      this._text_19,
      this._text_20,
      this._text_21,
      this._text_22,
      this._text_23,
      this._text_24,
      this._el_25,
      this._text_26,
      this._el_27,
      this._text_28,
      this._text_29,
      this._el_30,
      this._text_31,
      this._el_32,
      this._text_33,
      this._el_34,
      this._text_35,
      this._el_36,
      this._text_37,
      this._text_38,
      this._text_39,
      this._text_40,
      this._text_41,
      this._el_42,
      this._text_43,
      this._el_44,
      this._text_45,
      this._text_46,
      this._text_47,
      this._el_48,
      this._text_49,
      this._el_50,
      this._text_51,
      this._el_52,
      this._text_53,
      this._anchor_54,
      this._text_55,
      this._anchor_56,
      this._text_57,
      this._text_58,
      this._anchor_59,
      this._text_60,
      this._text_61,
      this._el_62,
      this._text_63,
      this._el_64,
      this._text_65,
      this._anchor_66,
      this._text_67,
      this._anchor_68,
      this._text_69,
      this._text_70,
      this._anchor_71,
      this._text_72,
      this._text_73,
      this._text_74
    ]
    ),[
      disposable_0,
      disposable_1,
      disposable_2,
      disposable_3
    ]
    );
    return (null as any);
  }
  injectorGetInternal(token:any,requestNodeIndex:number,notFoundResult:any):any {
    if (((token === import24.DefaultValueAccessor) && (16 === requestNodeIndex))) { return this._DefaultValueAccessor_16_3.context; }
    if (((token === import25.MaskedInputDirective) && (16 === requestNodeIndex))) { return this._MaskedInputDirective_16_4.context; }
    if (((token === import26.NG_VALUE_ACCESSOR) && (16 === requestNodeIndex))) { return this._NG_VALUE_ACCESSOR_16_5; }
    if (((token === import27.NgModel) && (16 === requestNodeIndex))) { return this._NgModel_16_6.context; }
    if (((token === import28.NgControl) && (16 === requestNodeIndex))) { return this._NgControl_16_7; }
    if (((token === import29.NgControlStatus) && (16 === requestNodeIndex))) { return this._NgControlStatus_16_8.context; }
    if (((token === import30.NgClass) && ((18 <= requestNodeIndex) && (requestNodeIndex <= 19)))) { return this._NgClass_18_3.context; }
    if (((token === import30.NgClass) && ((10 <= requestNodeIndex) && (requestNodeIndex <= 22)))) { return this._NgClass_10_3.context; }
    if (((token === import30.NgClass) && ((27 <= requestNodeIndex) && (requestNodeIndex <= 28)))) { return this._NgClass_27_3.context; }
    if (((token === import24.DefaultValueAccessor) && (34 === requestNodeIndex))) { return this._DefaultValueAccessor_34_3.context; }
    if (((token === import25.MaskedInputDirective) && (34 === requestNodeIndex))) { return this._MaskedInputDirective_34_4.context; }
    if (((token === import26.NG_VALUE_ACCESSOR) && (34 === requestNodeIndex))) { return this._NG_VALUE_ACCESSOR_34_5; }
    if (((token === import27.NgModel) && (34 === requestNodeIndex))) { return this._NgModel_34_6.context; }
    if (((token === import28.NgControl) && (34 === requestNodeIndex))) { return this._NgControl_34_7; }
    if (((token === import29.NgControlStatus) && (34 === requestNodeIndex))) { return this._NgControlStatus_34_8.context; }
    if (((token === import30.NgClass) && ((36 <= requestNodeIndex) && (requestNodeIndex <= 37)))) { return this._NgClass_36_3.context; }
    if (((token === import30.NgClass) && ((30 <= requestNodeIndex) && (requestNodeIndex <= 39)))) { return this._NgClass_30_3.context; }
    if (((token === import23.TemplateRef) && (54 === requestNodeIndex))) { return this._TemplateRef_54_5; }
    if (((token === import31.NgIf) && (54 === requestNodeIndex))) { return this._NgIf_54_6.context; }
    if (((token === import23.TemplateRef) && (56 === requestNodeIndex))) { return this._TemplateRef_56_5; }
    if (((token === import31.NgIf) && (56 === requestNodeIndex))) { return this._NgIf_56_6.context; }
    if (((token === import23.TemplateRef) && (59 === requestNodeIndex))) { return this._TemplateRef_59_5; }
    if (((token === import31.NgIf) && (59 === requestNodeIndex))) { return this._NgIf_59_6.context; }
    if (((token === import23.TemplateRef) && (66 === requestNodeIndex))) { return this._TemplateRef_66_5; }
    if (((token === import31.NgIf) && (66 === requestNodeIndex))) { return this._NgIf_66_6.context; }
    if (((token === import23.TemplateRef) && (68 === requestNodeIndex))) { return this._TemplateRef_68_5; }
    if (((token === import31.NgIf) && (68 === requestNodeIndex))) { return this._NgIf_68_6.context; }
    if (((token === import23.TemplateRef) && (71 === requestNodeIndex))) { return this._TemplateRef_71_5; }
    if (((token === import31.NgIf) && (71 === requestNodeIndex))) { return this._NgIf_71_6.context; }
    return notFoundResult;
  }
  detectChangesInternal(throwOnChange:boolean):void {
    const valUnwrapper:any = new import1.ValueUnwrapper();
    const currVal_10_0_0:any = 'eva-3-validation -lg -top-left';
    this._NgClass_10_3.check_klass(currVal_10_0_0,throwOnChange,false);
    const currVal_10_0_1:any = this._map_114(this.context.digitPhoneError1);
    this._NgClass_10_3.check_ngClass(currVal_10_0_1,throwOnChange,false);
    this._NgClass_10_3.ngDoCheck(this,this._el_10,throwOnChange);
    this._DefaultValueAccessor_16_3.ngDoCheck(this,this._el_16,throwOnChange);
    const currVal_16_1_0:any = this._map_115(this.context.mask,true);
    this._MaskedInputDirective_16_4.check_textMaskConfig(currVal_16_1_0,throwOnChange,false);
    this._MaskedInputDirective_16_4.ngDoCheck(this,this._el_16,throwOnChange);
    const currVal_16_2_0:boolean = !this.context.isValidLocation;
    this._NgModel_16_6.check_isDisabled(currVal_16_2_0,throwOnChange,false);
    const currVal_16_2_1:any = this.context.phoneOne;
    this._NgModel_16_6.check_model(currVal_16_2_1,throwOnChange,false);
    this._NgModel_16_6.ngDoCheck(this,this._el_16,throwOnChange);
    this._NgControlStatus_16_8.ngDoCheck(this,this._el_16,throwOnChange);
    const currVal_18_0_0:any = 'eva-3-label -md phone-prefix';
    this._NgClass_18_3.check_klass(currVal_18_0_0,throwOnChange,false);
    const currVal_18_0_1:any = this._map_116(!this.context.isValidLocation);
    this._NgClass_18_3.check_ngClass(currVal_18_0_1,throwOnChange,false);
    this._NgClass_18_3.ngDoCheck(this,this._el_18,throwOnChange);
    const currVal_27_0_0:any = 'eva-3-link';
    this._NgClass_27_3.check_klass(currVal_27_0_0,throwOnChange,false);
    const currVal_27_0_1:any = this._map_119(!this.context.isReqPhoneCompleted);
    this._NgClass_27_3.check_ngClass(currVal_27_0_1,throwOnChange,false);
    this._NgClass_27_3.ngDoCheck(this,this._el_27,throwOnChange);
    const currVal_30_0_0:any = 'eva-3-input -lg input-phone';
    this._NgClass_30_3.check_klass(currVal_30_0_0,throwOnChange,false);
    const currVal_30_0_1:any = this._map_123(this.context.digitPhoneError2);
    this._NgClass_30_3.check_ngClass(currVal_30_0_1,throwOnChange,false);
    this._NgClass_30_3.ngDoCheck(this,this._el_30,throwOnChange);
    this._DefaultValueAccessor_34_3.ngDoCheck(this,this._el_34,throwOnChange);
    const currVal_34_1_0:any = this._map_124(this.context.mask,true);
    this._MaskedInputDirective_34_4.check_textMaskConfig(currVal_34_1_0,throwOnChange,false);
    this._MaskedInputDirective_34_4.ngDoCheck(this,this._el_34,throwOnChange);
    const currVal_34_2_0:any = this.context.phoneTwo;
    this._NgModel_34_6.check_model(currVal_34_2_0,throwOnChange,false);
    this._NgModel_34_6.ngDoCheck(this,this._el_34,throwOnChange);
    this._NgControlStatus_34_8.ngDoCheck(this,this._el_34,throwOnChange);
    const currVal_36_0_0:any = 'eva-3-label -md phone-prefix';
    this._NgClass_36_3.check_klass(currVal_36_0_0,throwOnChange,false);
    const currVal_36_0_1:any = this._map_126(!this.context.isValidLocation);
    this._NgClass_36_3.check_ngClass(currVal_36_0_1,throwOnChange,false);
    this._NgClass_36_3.ngDoCheck(this,this._el_36,throwOnChange);
    const currVal_54_0_0:any = this.context.digitPhoneError1;
    this._NgIf_54_6.check_ngIf(currVal_54_0_0,throwOnChange,false);
    this._NgIf_54_6.ngDoCheck(this,this._anchor_54,throwOnChange);
    const currVal_56_0_0:any = this.context.incompletePhone1;
    this._NgIf_56_6.check_ngIf(currVal_56_0_0,throwOnChange,false);
    this._NgIf_56_6.ngDoCheck(this,this._anchor_56,throwOnChange);
    const currVal_59_0_0:any = this.context.isFreeLine1;
    this._NgIf_59_6.check_ngIf(currVal_59_0_0,throwOnChange,false);
    this._NgIf_59_6.ngDoCheck(this,this._anchor_59,throwOnChange);
    const currVal_66_0_0:any = this.context.digitPhoneError2;
    this._NgIf_66_6.check_ngIf(currVal_66_0_0,throwOnChange,false);
    this._NgIf_66_6.ngDoCheck(this,this._anchor_66,throwOnChange);
    const currVal_68_0_0:any = this.context.incompletePhone2;
    this._NgIf_68_6.check_ngIf(currVal_68_0_0,throwOnChange,false);
    this._NgIf_68_6.ngDoCheck(this,this._anchor_68,throwOnChange);
    const currVal_71_0_0:any = this.context.isFreeLine2;
    this._NgIf_71_6.check_ngIf(currVal_71_0_0,throwOnChange,false);
    this._NgIf_71_6.ngDoCheck(this,this._anchor_71,throwOnChange);
    this._vc_54.detectChangesInNestedViews(throwOnChange);
    this._vc_56.detectChangesInNestedViews(throwOnChange);
    this._vc_59.detectChangesInNestedViews(throwOnChange);
    this._vc_66.detectChangesInNestedViews(throwOnChange);
    this._vc_68.detectChangesInNestedViews(throwOnChange);
    this._vc_71.detectChangesInNestedViews(throwOnChange);
    valUnwrapper.reset();
    const currVal_110:any = import3.inlineInterpolate(1,'',valUnwrapper.unwrap(this._pipe_translate_0.transform('pickupPoint.phone.title')),'');
    if ((valUnwrapper.hasWrappedValue || import3.checkBinding(throwOnChange,this._expr_110,currVal_110))) {
      this.renderer.setText(this._text_1,currVal_110);
      this._expr_110 = currVal_110;
    }
    valUnwrapper.reset();
    const currVal_112:any = import3.inlineInterpolate(1,'',valUnwrapper.unwrap(this._pipe_translate_1.transform('pickupPoint.phone')),'');
    if ((valUnwrapper.hasWrappedValue || import3.checkBinding(throwOnChange,this._expr_112,currVal_112))) {
      this.renderer.setText(this._text_4,currVal_112);
      this._expr_112 = currVal_112;
    }
    this._NgControlStatus_16_8.checkHost(this,this,this._el_16,throwOnChange);
    const currVal_117:any = import3.inlineInterpolate(1,'\n                        ',this.context.phonePrefix,'');
    if (import3.checkBinding(throwOnChange,this._expr_117,currVal_117)) {
      this.renderer.setText(this._text_19,currVal_117);
      this._expr_117 = currVal_117;
    }
    const currVal_118:any = this.context.hideAddPhone;
    if (import3.checkBinding(throwOnChange,this._expr_118,currVal_118)) {
      this.renderer.setElementProperty(this._el_27,'hidden',currVal_118);
      this._expr_118 = currVal_118;
    }
    valUnwrapper.reset();
    const currVal_120:any = import3.inlineInterpolate(1,'',valUnwrapper.unwrap(this._pipe_translate_2.transform('pickupPoint.addPhone')),'');
    if ((valUnwrapper.hasWrappedValue || import3.checkBinding(throwOnChange,this._expr_120,currVal_120))) {
      this.renderer.setText(this._text_28,currVal_120);
      this._expr_120 = currVal_120;
    }
    const currVal_122:boolean = !this.context.hideAddPhone;
    if (import3.checkBinding(throwOnChange,this._expr_122,currVal_122)) {
      this.renderer.setElementProperty(this._el_30,'hidden',currVal_122);
      this._expr_122 = currVal_122;
    }
    this._NgControlStatus_34_8.checkHost(this,this,this._el_34,throwOnChange);
    const currVal_125:boolean = !this.context.hideAddPhone;
    if (import3.checkBinding(throwOnChange,this._expr_125,currVal_125)) {
      this.renderer.setElementProperty(this._el_36,'hidden',currVal_125);
      this._expr_125 = currVal_125;
    }
    const currVal_127:any = import3.inlineInterpolate(1,'',this.context.phonePrefix,'');
    if (import3.checkBinding(throwOnChange,this._expr_127,currVal_127)) {
      this.renderer.setText(this._text_37,currVal_127);
      this._expr_127 = currVal_127;
    }
    const currVal_128:boolean = !this.context.hideAddPhone;
    if (import3.checkBinding(throwOnChange,this._expr_128,currVal_128)) {
      this.renderer.setElementProperty(this._el_44,'hidden',currVal_128);
      this._expr_128 = currVal_128;
    }
  }
  destroyInternal():void {
    this._vc_54.destroyNestedViews();
    this._vc_56.destroyNestedViews();
    this._vc_59.destroyNestedViews();
    this._vc_66.destroyNestedViews();
    this._vc_68.destroyNestedViews();
    this._vc_71.destroyNestedViews();
    this._NgModel_16_6.ngOnDestroy();
    this._NgModel_34_6.ngOnDestroy();
    this._pipe_translate_0.ngOnDestroy();
    this._pipe_translate_1.ngOnDestroy();
    this._pipe_translate_2.ngOnDestroy();
  }
  createEmbeddedViewInternal(nodeIndex:number):import2.AppView<any> {
    if ((nodeIndex == 54)) { return new View_PhoneContainerComponent1(this.viewUtils,this,54,this._anchor_54,this._vc_54); }
    if ((nodeIndex == 56)) { return new View_PhoneContainerComponent2(this.viewUtils,this,56,this._anchor_56,this._vc_56); }
    if ((nodeIndex == 59)) { return new View_PhoneContainerComponent3(this.viewUtils,this,59,this._anchor_59,this._vc_59); }
    if ((nodeIndex == 66)) { return new View_PhoneContainerComponent4(this.viewUtils,this,66,this._anchor_66,this._vc_66); }
    if ((nodeIndex == 68)) { return new View_PhoneContainerComponent5(this.viewUtils,this,68,this._anchor_68,this._vc_68); }
    if ((nodeIndex == 71)) { return new View_PhoneContainerComponent6(this.viewUtils,this,71,this._anchor_71,this._vc_71); }
    return (null as any);
  }
  handleEvent_16(eventName:string,$event:any):boolean {
    this.markPathToRootAsCheckOnce();
    var result:boolean = true;
    result = (this._DefaultValueAccessor_16_3.handleEvent(eventName,$event) && result);
    result = (this._MaskedInputDirective_16_4.handleEvent(eventName,$event) && result);
    if ((eventName == 'blur')) {
      const pd_sub_0:any = ((<any>this.context.checkingPhone($event.target.value,1)) !== false);
      result = (pd_sub_0 && result);
    }
    if ((eventName == 'ngModelChange')) {
      const pd_sub_1:any = ((<any>(this.context.phoneOne = $event)) !== false);
      result = (pd_sub_1 && result);
    }
    if ((eventName == 'keyup')) {
      const pd_sub_2:any = ((<any>this.context.onKeyUpPress($event.target.value,1)) !== false);
      result = (pd_sub_2 && result);
    }
    return result;
  }
  handleEvent_27(eventName:string,$event:any):boolean {
    this.markPathToRootAsCheckOnce();
    var result:boolean = true;
    if ((eventName == 'click')) {
      const pd_sub_0:any = ((<any>this.context.addPhone()) !== false);
      result = (pd_sub_0 && result);
    }
    return result;
  }
  handleEvent_34(eventName:string,$event:any):boolean {
    this.markPathToRootAsCheckOnce();
    var result:boolean = true;
    result = (this._DefaultValueAccessor_34_3.handleEvent(eventName,$event) && result);
    result = (this._MaskedInputDirective_34_4.handleEvent(eventName,$event) && result);
    if ((eventName == 'blur')) {
      const pd_sub_0:any = ((<any>this.context.checkingPhone($event.target.value,2)) !== false);
      result = (pd_sub_0 && result);
    }
    if ((eventName == 'ngModelChange')) {
      const pd_sub_1:any = ((<any>(this.context.phoneTwo = $event)) !== false);
      result = (pd_sub_1 && result);
    }
    if ((eventName == 'keyup')) {
      const pd_sub_2:any = ((<any>this.context.onKeyUpPress($event.target.value,2)) !== false);
      result = (pd_sub_2 && result);
    }
    return result;
  }
  handleEvent_44(eventName:string,$event:any):boolean {
    this.markPathToRootAsCheckOnce();
    var result:boolean = true;
    if ((eventName == 'click')) {
      const pd_sub_0:any = ((<any>this.context.deletePhone()) !== false);
      result = (pd_sub_0 && result);
    }
    return result;
  }
}


// WEBPACK FOOTER //
// ./aot/public/upgrade/feature/additionalPoint/phone-component/phone.container.component.ngfactory.ts